import * as echarts from 'echarts'
import { sortBy } from '@/utils/handleData.js'
import { decimalDiv, decimalMul } from './getCalculatedValue'
// 获取饼图option
export function getPie(pieData, name, unit) {
  var seriesData = []
  var allNum = 0
  pieData.forEach((item) => {
    seriesData.push({
      name: item.label,
      value: item.value
    })
    allNum = allNum + item.value
  })
  var series = [
    {
      name: name,
      type: 'pie',
      radius: ['60%', '80%'],
      center: ['30%', '50%'],
      color: [
        '#5182FF',
        '#87D567',
        '#FF9A4B',
        '#FF5F5F',
        '#73C7FF',
        '#FFD540',
        '#A0A7B4'
      ],
      label: {
        show: true,
        position: 'center',
        fontSize: '18',
        formatter: name + '\n\n' + allNum + '\xa0' + unit,
        fontWeight: 'bold',
        color: '#5182FF'
      },
      emphasis: {
        label: {
          show: true,
          fontSize: '18',
          fontWeight: 'bold'
        }
      },
      labelLine: {
        show: false
      },
      data: seriesData,
      itemStyle: {
        // 数可以设置诸如阴影、透明度、颜色、边框颜色、边框宽度等：
        shadowBlur: 10,
        shadowColor: 'rgba(0, 0, 0, 0.5)',
        borderWidth: 10,
        borderType: 'solid'
      }
    },
    {
      type: 'pie',
      zlevel: 1,
      silent: true,
      center: ['30%', '50%'],
      radius: ['87%', '88%'],
      color: '#EDEFF4',
      label: {
        show: false
      },
      labelLine: {
        show: false
      },
      data: [
        {
          value: 10,
          itemStyle: {
            borderWidth: 1, // 设置边框粗细
            borderColor: '#EDEFF4' // 边框颜色
          }
        }
      ]
    }
  ]
  var tooltip = {
    trigger: 'item',
    formatter: '{a} <br/>{b}: {c} ({d}%)'
  }
  var legend = {
    show: true,
    orient: 'vertical',
    left: '60%',
    top: 'middle',
    itemGap: 20,
    formatter: function (name) {
      for (var i = 0; i < seriesData.length; i++) {
        if (name === seriesData[i].name) {
          return name + '(\xa0' + seriesData[i].value + '\xa0' + unit + ')'
        }
      }
    }
  }
  var pieOption = {
    tooltip: tooltip,
    legend: legend,
    series: series
  }
  return pieOption
}

export function getEmptyPie(name, unit) {
  const option = getPie([{ label: '暂无', value: 1 }], name, unit)
  if (option.series && option.series[0]) {
    option.series[0].color = ['#E8EBF2']
    option.series[0].label.formatter = name + '\n\n0\xa0' + unit
    option.series[0].label.fontSize = 14
    option.series[0].itemStyle = Object.assign({}, option.series[0].itemStyle, {
      shadowBlur: 0,
      borderWidth: 0
    })
    option.series[0].emphasis = {
      scale: false,
      label: {
        show: true,
        fontSize: 14,
        fontWeight: 'bold'
      }
    }
  }
  if (option.legend) {
    option.legend.show = false
  }
  if (option.tooltip) {
    option.tooltip.formatter = name + '：0' + unit
  }
  return option
}

// 获取水浪球liquidfill
export function getliquidfill(rate, name) {
  var series = [
    {
      type: 'liquidFill',
      radius: '88%',
      center: ['50%', '50%'],
      data: [rate, rate, rate, rate, rate], // data个数代表波浪数
      label: {
        fontSize: 32,
        color: '#047BFF'
      },
      outline: {
        show: true,
        borderDistance: 10, // 边框线与图表的距离 数字
        itemStyle: {
          // opacity: 1, // 边框的透明度   默认为 1
          borderWidth: 2, // 边框的宽度
          // shadowBlur: 1, // 边框的阴影范围 一旦设置了内外都有阴影
          // shadowColor: '#fff', // 边框的阴影颜色,
          borderColor: '#EDEFF4' // 边框颜色
        }
      },
      // 图形样式
      itemStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0.9,
              color: 'rgba(24,94,255,1)'
            },
            {
              offset: 0.1,
              color: 'rgba(133,201,255,1)'
            },
            {
              offset: 0,
              color: 'rgba(133,201,255,1)'
            }
          ],
          globalCoord: false
        },
        opacity: 0.9, // 波浪的透明度
        shadowBlur: 10 // 波浪的阴影范围
      },
      backgroundStyle: {
        color: '#ffffff', // 水球未到的背景颜色
        opacity: 0.5
      }
    }
  ]
  var graphic = [
    {
      type: 'group',
      left: 'center',
      top: '62%',
      children: [
        {
          type: 'text',
          z: 100,
          left: 'center',
          top: 'middle',
          style: {
            fill: '#FF5F5F',
            text: name,
            font: '16px Microsoft YaHei'
          }
        }
      ]
    }
  ]
  var liquidfill = {
    graphic: graphic,
    series: series
  }
  return liquidfill
}

// 获取折线图option
export function getLine(lineData, names, units) {
  var seriesData = []
  var xAxisData = []
  var allSeriesData = []
  names.forEach((name, index) => {
    seriesData[index] = []
    const valueKey = 'value' + (index ? index + 1 : '')
    lineData.forEach((item) => {
      if (index === 0) {
        xAxisData.push(item.label)
      }
      seriesData[index].push(item[valueKey])
      allSeriesData.push(item[valueKey])
    })
  })
  allSeriesData = allSeriesData.sort(sortBy())
  var max = allSeriesData[allSeriesData.length - 1]
  const pow = (parseInt(max) + '').length - 1
  var interval = max
    ? Math.round(max / Math.pow(10, pow)) * (Math.pow(10, pow) / 5)
    : 0
  var series = [
    {
      data: seriesData[0],
      name: names[0],
      type: 'line',
      center: ['50%', '50%'],
      lineStyle: {
        color: '#447FFF'
      },
      areaStyle: {
        // 区域颜色
        color: new echarts.graphic.LinearGradient(
          0,
          0,
          0,
          1,
          [
            {
              offset: 0,
              color: 'rgba(118,195,250,0.8)'
            },
            {
              offset: 0.5,
              color: 'rgba(118,195,250,0.4)'
            },
            {
              offset: 1,
              color: 'rgba(118,195,250,0.01)'
            }
          ],
          false
        )
      }
    }
  ]
  var tooltip = {
    trigger: 'axis',
    formatter: '{b}<br/> {a}: {c}'
  }
  var legend = {
    show: true,
    type: 'plain',
    data: names,
    x: 100,
    y: 'top',
    fontSize: 16,
    fontWeight: 'bold'
  }
  var grid = {
    // 图表距容器的位置
    top: 10,
    left: 10,
    right: 10,
    bottom: 0,
    containLabel: true
  }
  var xAxis = {
    type: 'category',
    boundaryGap: false,
    data: xAxisData
  }
  var yAxis = [
    {
      type: 'value',
      min: 0,
      max: max,
      interval: interval,
      axisLabel: {
        formatter: function (value) {
          return value + '\xa0\xa0' + (units && units[0] ? units[0] : '')
        }
      },
      splitLine: {
        lineStyle: {
          color: '#e6e6e6'
        }
      }
    }
  ]
  var lineOption = {
    color: ['#047bff'],
    tooltip: tooltip,
    legend: legend,
    xAxis: xAxis,
    yAxis: yAxis,
    grid: grid,
    series: series
  }
  return lineOption
}

// 获取柱状图option
export function getBar(barData, names, units, color) {
  var seriesData = []
  var xAxisData = []
  var allSeriesData = []
  names.forEach((name, index) => {
    seriesData[index] = []
    const valueKey = 'value' + (index ? index + 1 : '')
    barData.forEach((item) => {
      if (index === 0) {
        xAxisData.push(item.label)
      }
      seriesData[index].push(item[valueKey])
      allSeriesData.push(item[valueKey])
    })
  })

  allSeriesData = allSeriesData.sort(sortBy())
  var max = allSeriesData[allSeriesData.length - 1]
  const pow = (parseInt(max) + '').length - 1
  var interval = max
    ? decimalMul(
        Math.round(decimalDiv(max, Math.pow(10, pow))),
        decimalDiv(Math.pow(10, pow), 5)
      )
    : 0
  var yMax = max && interval ? decimalMul(interval, 6) : max
  var series = seriesData.map((item, index) => {
    return {
      data: item,
      name: names[index],
      type: 'bar',
      barMaxWidth: 40,
      barCategoryGap: '40%',
      label: {
        show: true,
        position: 'top',
        fontSize: 12,
        formatter: function (val) {
          if (val.value !== 0 && val.value != null && val.value !== '') {
            return val.value
          }
          return ''
        }
      },
      itemStyle: {
        borderRadius: [5, 5, 0, 0]
      }
    }
  })
  var tooltip = {
    trigger: 'axis'
  }
  var legend = {
    show: true,
    data: names,
    left: color ? 50 : 100,
    top: -5,
    fontSize: 14,
    fontWeight: 'bold',
    textStyle: color
      ? {
          color: color
        }
      : {}
  }
  var grid = {
    // 图表距容器的位置；顶部留白给柱顶数值
    top: 32,
    left: 10,
    right: 60,
    bottom: 0,
    containLabel: true
  }
  var xAxis = {
    type: 'category',
    boundaryGap: false,
    data: xAxisData,
    axisLabel: {
      color: color ? color : null
    }
  }
  var yAxis = {
    type: 'value',
    min: 0,
    max: yMax,
    interval: interval,
    axisLabel: {
      formatter: function (value) {
        return value + '\xa0\xa0' + (units && units[0] ? units[0] : '')
      },
      color: color ? color : null
    }
  }
  var lineOption = {
    color: [
      '#5182FF',
      '#87D567',
      '#FF9A4B',
      '#FF5F5F',
      '#73C7FF',
      '#FFD540',
      '#9900EF'
    ],
    tooltip: tooltip,
    legend: legend,
    xAxis: xAxis,
    yAxis: yAxis,
    grid: grid,
    series: series
  }
  return lineOption
}
